import React from "react";

const GlobalContext = React.createContext();

const GlobalContextProvider = (props) => {
  const [isMobile, setIsMobile] = React.useState(false);

  //* function to set isMobile state dependent on screen size
  const changeScreenSize = () => {
    const screenWidth = window.innerWidth;

    if (screenWidth >= 992) {
      setIsMobile(false);
    } else {
      setIsMobile(true);
    }
  };

  //* useEffect which listen to window resize
  React.useEffect(() => {
    changeScreenSize();
    window.addEventListener("resize", changeScreenSize);
    return () => window.removeEventListener("resize", changeScreenSize);
  }, []);

  return (
    <div>
      <GlobalContext.Provider value={{ isMobile }}>
        {props.children}
      </GlobalContext.Provider>
    </div>
  );
};

export { GlobalContext, GlobalContextProvider };
